export default "__VITE_ASSET__xISNpcXn__"